import { isPlatformServer, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { sleep } from 'src/app/lib/sleep';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TransitionPreventorDirective } from '../../../shared/directives/transition-preventor.directive';

@Component({
  selector: 'app-toggler',
  templateUrl: './toggler.component.html',
  styleUrls: ['./toggler.component.scss'],
  standalone: true,
  imports: [TransitionPreventorDirective, NgIf, SvgComponent],
})
export class TogglerComponent implements OnChanges {
  @Input() open = false;
  @Input() color: 'white' | 'grey-80' = 'white';
  @Input() headerSize: 'normal' | 'small' | 'big' | 'tiny' = 'normal';
  @Input() iconSize: 'normal' | 'small' = 'normal';
  @Input() hoverColor: 'none' | 'grey' = 'none';
  @Input() hideIcon = false;
  @Input() blockOpen = false;
  @Input() bodyPadding: 'normal' | 'small' | 'none';
  @Input() special = '';
  @Output() onOpen = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @ViewChild('togglerBody', { static: true }) togglerBody: ElementRef<HTMLElement>;
  @HostListener('window:resize', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  winResize() {} // Just here to force the height to be fetched again
  bodyHeight: string;

  constructor(@Inject(PLATFORM_ID) private platformId: string) {
    this.calcBodyHeight();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.open) {
      this.calcBodyHeight();
    }
  }

  toggle() {
    if (this.blockOpen) return;
    this.open = !this.open;
    if (this.open) this.onOpen.emit();
    else this.onClose.emit();
    this.calcBodyHeight();
  }

  async calcBodyHeight() {
    await sleep(0);
    if (!this.open) return (this.bodyHeight = '0px');
    if (isPlatformServer(this.platformId)) return (this.bodyHeight = 'auto');
    const spacing = this.bodyPadding === 'none' ? 0 : this.bodyPadding === 'small' ? 5 : 20;
    const height = this.togglerBody.nativeElement.querySelector('*').getBoundingClientRect().height + spacing + 'px';
    this.bodyHeight = height;
  }
}
